import { useEffect, useState } from "react";
import { SEO } from "@/components/SEO";


import { HeroSection } from "@/components/home/HeroSection";
import { LiveMetricsStrip } from "@/components/home/LiveMetricsStrip";
import { SolutionsGrid } from "@/components/home/SolutionsGrid";
import { DOOHShowcaseSection } from "@/components/home/DOOHShowcaseSection";


import { CoverageMapSection } from "@/components/home/CoverageMapSection";
import { CTASection } from "@/components/home/CTASection";

const Home = () => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => { setIsVisible(true); }, []);

  return (
    <div className="relative min-h-screen">
      <SEO
        title="Fusion Media — All-in-One Advertising Platform in Saudi Arabia"
        description="Saudi Arabia's all-in-one programmatic platform for DOOH screens, influencers, and event sponsorships. Launch high-impact campaigns in minutes."
      />
      <div className="relative max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8">

        <div data-tour="home-hero">
          <HeroSection isVisible={isVisible} />
        </div>

        <div data-tour="home-features" className="pb-12 md:pb-16">
          <LiveMetricsStrip />
        </div>

        <div className="pb-16 md:pb-24">
          <DOOHShowcaseSection />
        </div>

        <div className="pb-16 md:pb-24">
          <SolutionsGrid />
        </div>


        <div className="pb-16 md:pb-24">
          <CoverageMapSection />
        </div>


        <div data-tour="home-cta" className="pb-16 md:pb-24">
          <CTASection />
        </div>
      </div>
    </div>
  );
};

export default Home;
